import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../common/hookFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'annualSpinningCapacity',
    type: 'text',
    label: 'Capacity (In Tons)',
  },
];

export const AnnualCapacityFieldsValidation = {
  [fields[0].name]: yup.string(),
};

const AnnualCapacitySection = (props) => {
  return (
    <FormSection
      sectionName="Annual Spinning Capacity"
      sectionColumn={2}
      formFields={fields}
      {...props}
    />
  );
};

export default AnnualCapacitySection;
